<script setup lang="ts">
import { provide, ref } from "vue";
import Home from "./components/Home.vue";
import Monitor from "./components/monitor.vue";

export type PageName = "home" | "dashboard";

const page = ref<PageName>("home");
const go = (target: PageName) => {
  page.value = target;
};
provide("go", go);
</script>

<template>
  <Home v-if="page === 'home'" />
  <Monitor v-else />
</template>
